import { exists, Logger, resolveContent, RuntimeModules } from '@nu-art/ts-common';
import { DataStatus } from '../../core/db-api-gen/consts.js';
import { Thunder } from '../../core/Thunder.js';
export class AwaitModules_FunctionWrapper extends Logger {
    modules;
    callback;
    readyState;
    pending = [];
    listening = false;
    //######################### Life Cycle #########################
    __onSyncStatusChanged(module) {
        this.logVerbose(`__onSyncStatusChanged: ${module.getCollectionName()}`);
        if (!this.modules.includes(module))
            return;
        this.tryResolvePending();
    }
    constructor(modules, callback) {
        super();
        const runtimeModules = RuntimeModules();
        this.callback = callback;
        this.readyState = false;
        this.modules = resolveContent(modules).filter(m => {
            if (!runtimeModules.includes(m)) {
                this.logWarning(`Got module ${m.getName()}, but it isn't in RuntimeModules!`);
                return false;
            }
            if (!exists(m.dbDef)) {
                this.logWarning(`Got module ${m.getName()}, but it doesn't have a dbDef!`);
                return false;
            }
            return true;
        });
    }
    //######################### Internal logic #########################
    isReady = () => {
        if (this.readyState)
            return true;
        const ready = this.modules.every(m => m.getDataStatus() === DataStatus.ContainsData);
        if (ready)
            this.readyState = true;
        return this.readyState;
    };
    attachListener = () => {
        if (this.listening)
            return;
        // @ts-ignore
        Thunder.getInstance().addUIListener(this);
        this.listening = true;
    };
    detachListener = () => {
        if (!this.listening)
            return;
        // @ts-ignore
        Thunder.getInstance().removeUIListener(this);
        this.listening = false;
    };
    tryResolvePending = () => {
        if (!this.isReady() || this.pending.length === 0)
            return;
        //Modules are ready, detach the listener and flush all waiters with their own args
        this.detachListener();
        const waiters = this.pending;
        this.pending = [];
        for (const waiter of waiters) {
            try {
                waiter.resolve(this.callback(...waiter.args));
            }
            catch (e) {
                waiter.reject(e);
            }
        }
    };
    //######################### Public Interface #########################
    execute = (...args) => {
        if (this.isReady())
            return new Promise((resolve, reject) => {
                try {
                    resolve(this.callback(...args));
                }
                catch (e) {
                    reject(e);
                }
            });
        return new Promise((resolve, reject) => {
            this.pending.push({ args, resolve, reject });
            this.attachListener();
        });
    };
}
//# sourceMappingURL=function-wrapper.js.map